export default __webpack_public_path__ + "static/media/toyota.887e9102.svg";